<template>
    <div class="products-website-shopify">
        <g-typography tag="p" value="Head to our website and select the products you’d like to receive." />
        <!-- TODO: turn `panel-drop` into component or find where it's used elsewhere if it already exists -->
        <div class="panel-drop">
            <div class="header">
                <g-icon class="icon" name="chevron-down" />
                <g-typography class="title" tag="h4" font-weight="semibold" value="Instructions" />
            </div>
            <div class="content">
                <!-- TODO: turn into `g-typography` and have it support needed colors and sizes -->
                <ol>
                    <li>
                        Go to our website: <a :href="storeUrl" class="link" target="_blank">{{ storeUrlDisplay }}</a>
                    </li>
                    <li>Browse our catalog and click an item you want.</li>
                    <li>Copy the product URL and paste it below.</li>
                    <li>Click Add Product.</li>
                    <li>Redo this for any other product you wish to add.</li>
                </ol>
                <div class="sample">
                    <div>The link should look similar to this:</div>
                    <div>{{ storeUrlDisplay }}/Product-name</div>
                </div>
            </div>
        </div>
        <div class="large-input">
            <g-input
                v-model="storeProductUrl"
                :class="{ 'error-input': showError }"
                placeholder="Store Product URL"
                :disabled="isLoadingProducts || productLimitReached"
            />
            <g-tooltip v-if="productLimitReached" placement="top" title="You've reached your product limit.">
                <g-button
                    type="primary"
                    :loading="isLoadingProducts"
                    :disabled="isLoadingProducts || productLimitReached"
                    @click="handleURLSubmit"
                >
                    Add Product
                </g-button>
            </g-tooltip>
            <g-button
                v-else
                type="primary"
                :loading="isLoadingProducts"
                :disabled="isLoadingProducts"
                @click="handleURLSubmit"
            >
                Add Product
            </g-button>
        </div>
        <g-typography v-if="showError" color="error"> Oops, wrong URL. Let's try this again. </g-typography>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefProductConfigMixin from '../../mixins/ActivationBriefProductConfigMixin';
    import ActivationBriefProductsMixin from '../../../../providers/mixins/ActivationBriefProductsMixin';

    export default {
        name: 'ProductsWebsiteShopify',
        mixins: [ActivationBriefProductConfigMixin, ActivationBriefProductsMixin],
        props: {
            productLimitReached: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                storeProductUrl: null,
                showError: false
            };
        },
        computed: {
            storeUrlDisplay() {
                return get(this.brief, 'brand.website_url', '').replace(/\/$/, '');
            },
            storeUrl() {
                return this.storeUrlDisplay.startsWith('http') ? this.storeUrlDisplay : `//${this.storeUrlDisplay}`;
            }
        },
        methods: {
            handleURLSubmit() {
                this.showError = false;
                this.getProductsFromStoreProductUrl(this.brief.id, this.storeProductUrl)
                    .then((product) => {
                        if (product) {
                            this.$emit(
                                'selected',
                                product,
                                this.findProductVariantOptionValues(product.variants, product.variant_id)
                            );

                            this.storeProductUrl = '';
                        }
                    })
                    .catch(() => (this.showError = true));
            },
            findProductVariantOptionValues(variants, variantId) {
                const variant = variants.find((item) => item.id === variantId);

                return variant ? variant.option_values.map(this.transformOptionValues) : [];
            },
            transformOptionValues(optionValue) {
                return {
                    value_id: optionValue.id,
                    id: optionValue.option_id,
                    name: optionValue.name
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .products-website-shopify {
        .panel-drop {
            margin-top: 30px;
            width: 100%;
            border: 1px #d7dbdf solid;
            border-radius: 4px;
            overflow: hidden;
            .header {
                background-color: #f9fafb;
                height: 46px;
                display: flex;
                align-items: center;
                font-size: 15px;
                border-bottom: 1px #d7dbdf solid;
                padding: 0 24px;
                cursor: pointer;
                .icon {
                    position: relative;
                    font-size: 13px !important;
                }
                .title {
                    margin-left: 4px;
                }
            }
            .content {
                padding: 8px 24px;
                .link {
                    color: $g-color-primary;
                }
                ol {
                    position: relative;
                    left: -10px;
                }
                .sample {
                    font-size: 12px;
                    color: #636a71;
                }
            }
        }
        .large-input {
            margin-top: 20px;
            height: 40px;
            width: 100%;
            display: flex;
        }
        .error-input {
            border-color: $g-font-color-error;
        }
    }
</style>
